import { render, staticRenderFns } from "./SubscriptionPlans.vue?vue&type=template&id=3a7527bc&scoped=true&"
import script from "./SubscriptionPlans.vue?vue&type=script&lang=js&"
export * from "./SubscriptionPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7527bc",
  null
  
)

export default component.exports